import * as yup from 'yup';
import { EExtendedFieldTypes, EFormFieldsNames } from '../../../types/requestForm';

/**
 * TODO: Пока тему коммисионных вознаграждений передаем вручную в скрытое поле,
 * но в будущем при развитии продукта здесь появится поле другого типа, чтобы пользователь
 * мог сам выбирать нужную тему.
 */
export var PARTNER_REWARDS_SOURCE_FIELD = {
  field: {
    name: EFormFieldsNames.PartnerRewardsSource,
    type: EExtendedFieldTypes.HiddenField,
    required: true
  },
  validation: yup.string()
};